var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metacoBtn metacoWhite",on:{"click":_vm.handleClick}},[_c('Icon',{attrs:{"fill":"#045B9C","name":"metacoIcon","width":"22"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }